<template>
 <RouterView>

 </RouterView>
</template>

<script>
import {App} from "@capacitor/app";
import {StatusBar} from '@capacitor/status-bar';
import {ScreenOrientation} from "@capacitor/screen-orientation";
import Swals from "@/assets/js/Swals";
import router from "@/router";
export default {
  name: 'App',
  setup(){

    App.addListener('backButton', async () => {

      let url = window.location.href

     if (url.includes('HomePage')) {
       await Swals.Question('آیا از برنامه خارج می شوید؟' , 'خروج از برنامه').then((res)=>{
          if (res.isConfirmed){
            App.exitApp()
          }
        })
      }else if(url.includes('/ProductsManagement') || url.includes('/MyOrders') || url.includes('OffersPage') || url.includes('MyAuctions')){

      await router.push({name:'HomePage'})

     } else if(url.includes('/ProductsPage')){

       await router.push({name:'ProductsManagement'})

     } else if(url.includes('/OtpPage') || url.includes('RegisterPage')){

       await router.push({name:'LoginPage'})

     } else if (url.includes('/LoginPage')) {
        await App.exitApp()
      }else{
      await window.history.back()
     }


    })

    StatusBar.setBackgroundColor({color: '#2F3A96'})
    ScreenOrientation.lock({orientation: 'OrientationLockType'})

    window.addEventListener('online' , ()=>{
      Swals.Done('اتصال اینترنت شما برقرار شد :)')
    })

    window.addEventListener('offline' , ()=>{
      Swals.Warning('متاسفانه اتصال اینترنت برقرار نیست !')
    })

  }
}
</script>


<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
